<template>
  <footer class="footer bg-light">
    <div class="container">
      <div class="row">
        <div
          class="versao col-md-3 col-lg-2 d-none d-sm-block pl-0 text-center align-self-center "
        >
          <span  v-if="isAuthenticated">{{ versao }}</span>
        </div>
        <div
          class=" texto-centro col-sm text-center align-self-center "
        >
          <div>Prefeitura Municipal de Belo Horizonte</div>
          <div>Av. Afonso Pena 1212 - 30130-908 / Belo Horizonte - MG </div> 
        </div>
        <div class="col-md-3 col-lg-2 d-none d-md-block  text-center align-self-center">
          <img
            :src="logoURL"
            class="img-fluid"
            alt="Prefeitura de Belo Horizonte"
          >
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  name: "Rodape",
  props: {
    logoURL: { type: String, default: "" },
    versao: { type: String, default: "" },
  },

  computed: {
      ...mapGetters(['isAuthenticated']),   
  }
};
</script>
<style scoped>
  .footer .container .row .versao{
    font-size: 0.9em;
    color: gray;
  }

  .footer .container .row .texto-centro{
    font-size: 0.75em;
    color: gray;
  }

  .footer .container .row .img-fluid{
    width: 130px;
  }
</style>
